export const STATUS_CONSTS = {
    GET_STATUSES: "GET_STATUSES",
    CREATE_STATUS: "CREATE_STATUS",
    UPDATE_STATUS: "UPDATE_STATUS",
    DELETE_STATUS_BY_ID: "DELETE_STATUS_BY_ID",
};
